import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class StatsMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: StatsMetaModule,
            providers: [
                providePageMeta({
                    title: 'Dashboard',
                    translationKey: '',
                    routerLink: '/dashboard',
                    icon: 'pie-chart',
                    category: PageCategory.Tenant,
                    scope: PageScope.Folder,
                }),
                providePageMeta({
                    title: 'Dashboard',
                    translationKey: '',
                    routerLink: '/',
                    icon: 'pie-chart',
                    category: PageCategory.Tenant,
                    scope: PageScope.Folder,
                }),
            ],
        };
    }
}
